import { useMemo, useState, useCallback, useEffect } from 'react';
import {
  queryDetailKeyInfomation,
  queryDetailAbout,
  queryDetailNews,
  queryDetailProjectsLiveOfInternal,
  queryDetailProjectsLiveOfIntelligence,
  queryDetailProjectsInDev,
} from '@gp/pages/StudioDashboard/StudioOverall/services/studioOverallDetail';
import useDataTime from './useDataTime';
import { useRequest } from 'ahooks';

function requestDetailsData(props: { studioId: string; }) {
  const { studioId } = props;

  const [category, setCategory] = useState<'internal' | 'intelligence'>('internal');

  const { loading: keyInfomatLoading, data: keyInfomatData } = useRequest(
    queryDetailKeyInfomation,
    { defaultParams: [{ studio_id: studioId }] },
  );
  const { loading: aboutLoading, data: aboutData } = useRequest(queryDetailAbout, {
    defaultParams: [{ company_id: studioId }],
  });
  const { loading: newsLoading, data: newsData } = useRequest(queryDetailNews, {
    defaultParams: [{ company_id: studioId }],
  });
  const {
    loading: projectsLiveOfInternalLoading,
    data: projectsLiveOfInternalData,
    run: peojectsLiveOfInternalRun,
  } = useRequest(queryDetailProjectsLiveOfInternal, { manual: true });
  const {
    loading: projectsLiveOfIntelligenceLoading,
    data: projectsLiveOfIntelligenceData,
    run: peojectsLiveOfIntelligenceRun,
  } = useRequest(queryDetailProjectsLiveOfIntelligence, { manual: true });

  const { loading: projectsInDevLoading, data: projectsInDevData } = useRequest(
    queryDetailProjectsInDev,
    { defaultParams: [{ studio_id: studioId }] },
  );

  const { dataTime } = useDataTime(keyInfomatData);

  const { projectsLiveLoading, projectsLiveData } = useMemo(() => {
    return {
      projectsLiveLoading: projectsLiveOfInternalLoading || projectsLiveOfIntelligenceLoading,
      projectsLiveData:
        category === 'internal' ? projectsLiveOfInternalData : projectsLiveOfIntelligenceData,
    };
  }, [projectsLiveOfInternalLoading, projectsLiveOfIntelligenceLoading, category]);

  const handleProjectLiveChange = useCallback(
    (
      params: {
        studio_id: string;
        internal: boolean | undefined;
      },
      type: string, // internal | intelligence
    ) => {
      setCategory(type as 'internal' | 'intelligence');
      if (type === 'internal') {
        peojectsLiveOfInternalRun({
          select_id: [params?.studio_id],
          yoy: true,
          mom: true,
        });
      } else {
        peojectsLiveOfIntelligenceRun(params);
      }
    },
    [],
  );

  useEffect(() => {
    studioId &&
      peojectsLiveOfInternalRun({
        select_id: [studioId],
        yoy: true,
        mom: true,
      });
  }, [studioId]);

  return {
    dataTime,
    keyInfomatLoading,
    keyInfomatData,
    aboutLoading,
    aboutData,
    newsLoading,
    newsData,
    projectsLiveLoading,
    projectsLiveData,
    projectsInDevLoading,
    projectsInDevData,
    handleProjectLiveChange,
  };
}

export default requestDetailsData;
